class VideoManager {
  private currentVideo: HTMLVideoElement | HTMLIFrameElement | null = null;
  private static instance: VideoManager;

  private constructor() {}

  static getInstance(): VideoManager {
    if (!VideoManager.instance) {
      VideoManager.instance = new VideoManager();
    }
    return VideoManager.instance;
  }

  setCurrentVideo(video: HTMLVideoElement | HTMLIFrameElement): void {
    // 暂停之前的视频
    this.pauseCurrentVideo();

    // 设置新的视频为当前视频
    this.currentVideo = video;
  }

  pauseCurrentVideo(): void {
    if (this.currentVideo) {
      try {
        if ('pause' in this.currentVideo) {
          // HTML5 video element
          this.currentVideo.pause();
        } else if ('contentWindow' in this.currentVideo) {
          // YouTube iframe
          const iframe = this.currentVideo as HTMLIFrameElement;
          if (iframe.contentWindow) {
            // YouTube iframe API command to pause video
            // 需要确保iframe URL包含enablejsapi=1参数
            iframe.contentWindow.postMessage(
              JSON.stringify({
                event: "command",
                func: "pauseVideo",
                args: []
              }),
              '*'
            );
          }
        }
      } catch (error) {
        console.warn('Error pausing video:', error);
      }

      this.currentVideo = null;
    }
  }

  clearCurrentVideo(): void {
    this.currentVideo = null;
  }
}

export default VideoManager.getInstance();